webpackJsonp([39067687067054],{

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HeaderImage = __webpack_require__(58);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DonatePage = function DonatePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Donation" }),
	    _react2.default.createElement(_HeaderImage2.default, { headerImage: data.headerImage }),
	    _react2.default.createElement(
	      "div",
	      { className: "section" },
	      _react2.default.createElement(
	        "div",
	        { className: "container", style: { paddingTop: "100px" } },
	        _react2.default.createElement(
	          "h1",
	          { className: "title is-1" },
	          "Donation"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "donate-part1" },
	          "*** CICLE THING ***",
	          _react2.default.createElement(
	            "h2",
	            null,
	            "We are a ZERO profit fanbase! We do not get paid nor do we use any money for personal use. All donations STRICTLY go into keeping our fanbase active and to always better our content. This includes payments to keep the website up, keep our domain name, and to subscribe to better plans on uploading such as MEGA and Google Drive. We understand that we are still new and have a lot to show, but we hope that our current status and future show that we will surely put the funds to good use! All donations are greatly appreciated and NEVER required. We want ONCES to enjoy our content to the best quality!"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "outline-list" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Here is an outline where the money will go:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "Website hosting subscription"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Keeping the domain name (oncezone.com)"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Subscription to MEGA for uploading"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Subscription to extra Google Drive space for uploading"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Upgrading website"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "has-text-grey" },
	            "(click the buttons below to donate)"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "has-text-centered" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "All donations are kindly appreciated and will put into good use,",
	            _react2.default.createElement("br", null),
	            "Thank you for the warm support and we will keep working hard!"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "click-here" },
	            "Click Below to pay directly with Paypal or become a Patron!"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "a",
	              {
	                target: "_blank",
	                rel: "noopener noreferrer",
	                href: "https://www.paypal.me/OnceZone",
	                className: "button is-link donate-link"
	              },
	              "PayPal"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                target: "_blank",
	                rel: "noopener noreferrer",
	                className: "button is-link donate-link",
	                href: "https://www.patreon.com/bePatron?c=1360520"
	              },
	              "Become a Patron"
	            )
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Please fill up this form if you have made a donation!"
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              rel: "noopener noreferrer",
	              className: "button is-link",
	              href: "https://docs.google.com/forms/d/e/1FAIpQLSfB4nKu0H9d-G3dInbi0Dmz88ZU6cHgBQ6QVg-UUnUl6BCqwQ/viewform"
	            },
	            "Donation Form"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = DonatePage;
	
	/* eslint no-undef: "off" */
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-donate-jsx-20be2db09026efd931db.js